<template>
  <div>
    <h2 class="my-5 text-center"><strong>TERMOS E CONDIÇÕES DE USO</strong></h2>

    <p>
      O presente instrumento (“Termos de Uso”) regulamenta os termos e condições
      de uso do site “comenta.ai” (a “Plataforma”), pertencentes à RDR Serviços
      Digitais, sociedade limitada, inscrita no CNPJ sob nº 37.397.111/0001-93
      (o "Comenta.Aí”).
    </p>
    <p>
      O acesso à Plataforma pressupõe a compreensão de todas as condições,
      direitos e deveres a seguir descritos, bem como implica, para o Usuário (o
      “Usuário”) da Plataforma, a aceitação total e irrestrita dos Termos de
      Uso.
    </p>

    <h2 class="my-5 text-center">
      <strong>
        I – DISPOSIÇÕES INICIAIS
      </strong>
    </h2>

    <p>
      1.1. As atividades desenvolvidas através da Plataforma são pautadas pela
      ética e pela conformidade com o ordenamento jurídico vigente.
    </p>
    <p>
      1.2. O Comenta.Aí não utilizará de forma indevida qualquer informação
      coletada, prezando sempre pela intimidade e segurança do Usuário.
    </p>
    <p>
      1.3. O serviço prestado pelo Comenta.Aí consiste na intermediação entre o
      Usuário e o estabelecimento credenciado ao Comenta.Aí (o
      “Estabelecimento”), mediante disponibilização de ferramenta através da
      Plataforma, para fins de coleta e pesquisa de informações de satisfação (a
      “Pesquisa de Satisfação”) positiva e/ou negativa, realizada pelo Usuário,
      com relação aos serviços e atendimento oferecido pelo Estabelecimento.
    </p>
    <p>
      1.4. Em caso de não concordância aos Termos de Uso, o Usuário não deverá
      permanecer na Plataforma e, por consequência, não deverá realizar o
      preenchimento da pesquisa de satisfação.
    </p>

    <h2 class="my-5 text-center">
      <strong>II – SERVIÇOS E CONDIÇÕES DE USO</strong>
    </h2>

    <p>
      2.1. O objeto do presente Termo de Uso é a regulamentação da relação entre
      Usuário e Estabelecimento, através da Plataforma disponibilizada pelo
      Comenta.Aí, incluindo a descrição e as condições de uso dos serviços
      oferecidos, os direitos e deveres das partes e as limitações de garantias
      e de responsabilidades.
    </p>
    <p>
      2.2. O Usuário poderá realizar a Pesquisa de Satisfação do
      Estabelecimento, com seu aparelho celular, através da utilização de QR
      Code disponibilizado pelo Estabelecimento no formato de placa, em local de
      fácil acesso.
    </p>
    <p>
      2.3. O Usuário realizará a Pesquisa de Satisfação, mediante a seguinte
      sistemática:
    </p>
    <p>
      a) O Usuário irá apontar seu aparelho celular para o QR Code
      disponibilizado pelo Estabelecimento, que automaticamente abrirá a
      Plataforma.
    </p>
    <p>
      b) O Usuário poderá escolher, entre as duas opções que aparecerão na
      página inicial da Plataforma, como irá realizar a Pesquisa de Satisfação,
      se (i) de forma anônima, ou seja, sem disponibilização de seus dados
      pessoais (os “Dados Pessoais”); ou (ii) com disponibilização de seus Dados
      Pessoais através do Compartilhamento de Dados Pessoais (o
      “Compartilhamento de Dados Pessoais”).
    </p>
    <p class="ml-15">
      (i) se o Usuário escolher a forma anônima para realização da Pesquisa de
      Satisfação, será necessário apenas preencher os campos com sua avaliação e
      proceder com o envio para análise do Estabelecimento; e
    </p>
    <p class="ml-15">
      (ii) se o Usuário escolher disponibilizar seus Dados Pessoais para a
      realização da Pesquisa de Satisfação, será necessário realizar o
      Compartilhamento de Dados Pessoais, preencher os campos com sua avaliação
      e, por fim, enviar para análise do Estabelecimento.
    </p>
    <p>
      c) O Comenta.Aí compartilhará com o Estabelecimento os Dados Pessoais do
      Usuário que consentiu em disponibilizá-los ao escolher o Compartilhamento
      de Dados Pessoais.
    </p>

    <p>
      A critério do Estabelecimento, poderá o Usuário que optar pela
      disponibilização dos seus Dados Pessoais receber, na primeira vez em que
      fizer a avaliação de determinado Estabelecimento, uma bonificação (o
      “Bônus”), com base nas suas informações disponibilizadas e compartilhadas
      pelo Comenta.Aí, com: definição, quantidade e prazo de validade para o
      recebimento/utilização do Bônus, e conforme o regramento abaixo:
    </p>
    <p>
      a) O Usuário receberá/utilizará o Bônus, mediante apresentação de
      documento, para verificação dos Dados Pessoais do Usuário.
    </p>
    <p>
      b) O Bônus é nominativo, intransferível, não é cumulativo sendo permitida
      a utilização de um Bônus por vez, exceto se de outra forma estabelecido
      pelo Estabelecimento.
    </p>
    <p>
      c) A responsabilidade pelo cumprimento da entrega do Bônus ofertado ao
      Usuário, é inteiramente do Estabelecimento.
    </p>
    <p>
      2.6. O Comenta.Aí será responsável apenas pelo processamento e
      gerenciamento dos Dados Pessoais do Usuário que consentiu com o
      Compartilhamento dos Dados Pessoais na Plataforma.
    </p>
    <p class="ml-15">
      2.6.1. Após o compartilhamento de Dados Pessoais com o Estabelecimento, o
      Comenta.Aí não será responsável por atitudes adotadas pelo
      Estabelecimento.
    </p>
    <p>
      2.7. Para utilização da Plataforma é necessário conexão com a internet,
      sendo os custos de responsabilidade do Usuário. As falhas de comunicação
      ou do aparelho celular não são de responsabilidade do Comenta.Aí.
    </p>
    <p>
      2.10. Eventualmente, o sistema poderá não estar disponível por motivos
      técnicos ou falhas da internet, ou por qualquer outro evento fortuito ou
      de força maior alheio ao controle do Comenta.Aí.
    </p>

    <h2 class="my-5 text-center">
      <strong>III – COMPARTILHAMENTO DOS DADOS PESSOAIS</strong>
    </h2>

    <p>
      3.1. O Usuário poderá, a seu exclusivo critério, fazer o Compartilhamento
      dos Dados Pessoais quando realizar a Pesquisa de Satisfação.
    </p>
    <p>
      3.2. São os Dados Pessoais solicitados pela Comenta.Aí:
    </p>
    <p class="ml-15">
      a) Nome;<br />
      b) CPF; <br />
      c) Data de Nascimento; <br />
      d) Endereço de e-mail; <br />
      e) Telefone para contato.
    </p>
    <p>
      3.3. O Compartilhamento de Dados Pessoais ocorre no momento da avaliação e
      será utilizado somente para aquela Pesquisa de Satisfação específica
      respondida pelo Usuário a respeito de determinado Estabelecimento.
    </p>
    <p>
      3.4. Tendo em vista que o Comenta.Aí não faz qualquer tipo de cadastro do
      Usuário com os Dados Pessoais por ele fornecido, toda vez em que o Usuário
      preencher uma Pesquisa de Satisfação, desejando fazer o Compartilhamento
      dos Dados Pessoais, deverá o fazer de forma manual, uma vez que seus Dados
      Pessoais não serão memorizados pela Plataforma.
    </p>

    <h2 class="my-5 text-center">
      <strong>IV – LICENÇA E LIMITAÇÕES DE USO</strong>
    </h2>

    <p>
      4.1. Por meio deste Termo, o Comenta.Aí concede ao Usuário licença não
      exclusiva, intransferível e limitada para a utilização da Plataforma, para
      o fim específico de poder avaliar os Estabelecimentos credenciados.
    </p>
    <p>
      4.2. É expressamente proibido ao Usuário que disponibilizar seus Dados
      Pessoais através do Compartilhamento dos Dados Pessoais na Plataforma:
    </p>
    <p>
      a) Modificar, copiar, distribuir, transmitir, exibir, reproduzir,
      publicar, transferir, emprestar, alugar ou vender qualquer tipo de
      informação, software, produto ou serviço fornecidos pelo Comenta.Aí;
    </p>
    <p>
      b) Criar obras derivadas a partir das informações coletadas junto ao
      Comenta.Aí;
    </p>
    <p>
      c) Utilizar, de qualquer forma, técnicas de engenharia reversa para
      desenvolvimento ou criação de outros trabalhos com base no Comenta.Aí;
    </p>
    <p>
      d) Divulgar conteúdo ou arquivos sem autorização; e
    </p>
    <p>
      e) Liberar acesso a terceiros de forma ilícita.
    </p>
    <h2 class="my-5 text-center">
      <strong>
        V – PROPRIEDADE INTELECTUAL
      </strong>
    </h2>

    <p>
      5.1. O uso comercial da expressão “Comenta.Aí” como marca, nome
      empresarial ou nome de domínio, bem como os conteúdos das telas relativas
      aos serviços do Comenta.Aí assim como os programas, bancos de dados, redes
      e arquivos, que permitem que o Usuário realize o Compartilhamento de Dados
      Pessoais, são de propriedade do Comenta.Aí e estão protegidos pelas leis e
      tratados internacionais de direito autoral, marcas, patentes, modelos e
      desenhos industriais. O uso indevido e a reprodução total ou parcial dos
      referidos conteúdos são proibidos, salvo autorizados expressamente pelo
      Comenta.Aí.
    </p>
    <p>
      5.2. Não são de responsabilidade do Comenta.Aí, os conteúdos ou Bônus
      ofertados pelos Estabelecimentos.
    </p>
    <h2 class="my-5 text-center">
      <strong>
        VI – TRATAMENTO DE DADOS
      </strong>
    </h2>

    <p>
      6.1. O Comenta.Aí se obriga a realizar o tratamento de dados pessoais (o
      “Tratamento de Dados”), de acordo com as disposições legais vigentes, bem
      como nos moldes da Lei 13.709/2018, a Lei Geral de Proteção de Dados
      Pessoais (a “LGPD”), visando dar efetiva proteção aos dados coletados de
      pessoas naturais que possam identificá-las ou torna-las identificáveis,
      utilizando-os de tais dados tão-somente para os fins necessários à
      consecução do objeto deste Contrato, ou nos limites do consentimento
      expressamente manifestado por escrito por seus respectivos titulares.
    </p>
    <p>
      6.2. O Comenta.Aí terá acesso e armazenará os seus dados pessoais
      cadastrados na Plataforma, nos termos da Política de Privacidade do
      Comenta.Aí.
    </p>

    <h2 class="my-5 text-center"><strong>VII - DISPOSIÇÕES FINAIS</strong></h2>

    <p>
      7.1. O presente instrumento é regido e interpretado em conformidade com as
      leis vigentes do Brasil.
    </p>
    <p>
      7.2. Fica eleito o Foro da Comarca de Porto Alegre/RS para dirimir
      quaisquer controvérsias acerca do presente Termo de Uso que não puderem
      ser solucionadas de forma extrajudicial, com a exclusão de qualquer outro
      Foro, por mais privilegiado que possa ser.
    </p>
  </div>
</template>

<script>
export default {};
</script>

<style></style>
